import cloneDeep from 'lodash/cloneDeep';
export function serverSideSrc(plugins, serverCloudinaryImage) {
  var clonedServerCloudinaryImage = cloneDeep(serverCloudinaryImage);

  if (plugins) {
    for (var i = 0; i < plugins.length; i++) {
      var response = plugins[i](null, clonedServerCloudinaryImage);

      if (!response) {
        //lazyload
        break;
      }
    }
  }

  return clonedServerCloudinaryImage.toURL();
}